import React from "react";

export default function Other({
  otherCheck,
  setOtherCheck,
  otherValue,
  setOtherValue,
  setInputValue,
}) {
  const handleOtherCheck = (e) => {
    const isChecked = e.target.checked;

    setOtherCheck(isChecked);

    if (!isChecked) {
      // Remove the other value from Purchased when unchecked
      setInputValue((prev) => prev.filter((item) => item !== otherValue));
      setOtherValue(""); // Clear the input value
    }
  };


  console.log('otherCheck',otherCheck);
  
  const handleOtherValueChange = (e) => {
    const value = e.target.value;
    setOtherValue(value);

    setInputValue((prev) => {
      const filtered = prev.filter((item) => item !== otherValue); // Remove old value
      return value ? [...filtered, value] : filtered; // Add new value
    });
  };

  return (
    <>
      <div className="row mb-2">
        <div className="col-12">
          <input
            className="form-check-input"
            type="checkbox"
            checked={otherCheck}
            onChange={handleOtherCheck}
          />
          <label className="form-check-label" style={{ marginLeft: "1em" }}>
            Other
          </label>
        </div>
      </div>

      {otherCheck && (
        <div className="row mb-2">
          <div className="col-12">
            <input
              type="text"
              placeholder="Enter other value"
              className="form-control"
              value={otherValue}
              onChange={handleOtherValueChange}
            />
          </div>
        </div>
      )}
    </>
  );
}
